module.exports = __webpack_public_path__ + "img/back.28fff3e5.svg";